import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WebService } from '../../shared/services/web.service';
import { VERSION, MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { EventManagerService } from '../../shared/services/event-manager.service';
//import { MymodelComponent } from '../mymodel/mymodel.component';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgForm } from '@angular/forms';
import { SecureLocalStorage } from 'src/app/shared/services/secure-local-storage';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map, takeUntil, retry, mergeMap } from 'rxjs/operators';
import { debug } from 'util';
import { data } from 'jquery';
import { async } from '@angular/core/testing';
import { AuthenticateService } from '../authenticate.service';
import { Auth } from '../auth.service';
declare var bootbox: any;
declare var $: any;
@Component({
  selector: 'app-register-session',
  templateUrl: './register-component.html',
  styleUrls: ['./register-component.scss'],
  encapsulation: ViewEncapsulation.None,
})


export class RegisterComponent {
  hideEmailbut: boolean = false;
  hideMobilebut: boolean = false;
  hidedropvalue: string;
  mobileRelation: any;
  emailRelation: any;
  Apiurl: string;
  name: string;
  email: string;
  password: string;
  passwordConfirm: string;
  registerobj = new registerobj();
  registerobj1 = new registerobj();
  registerobj2 = new registerobj();
  searchfamily = new SearchContactParm();
  EkycRefCode: any;
  Contactvalue: any;
  userType: string;
  RefCodeType: string;
  Rmcode: string;
  defaultproductid: string = 'P000001';
  rmtoken: any;
  RmToken: any = [];
  DropDownGroupArr: any[];
  RelationDropdown: any[];
  loginID: any;
  resultData: any;
  Hidediv: boolean = false;
  validation: boolean = false;
  refcodeValue: boolean = false;
  otpvalidation: boolean = false;
  referalmcode: boolean = false;
  arrayLikeObj1: any[];
  dropdownlist: any[];
  @ViewChild('registrationfrm') registrationfrm: NgForm;
  @ViewChild('verifyForm') verifyForm: NgForm;
  RelationDropdown_codedesc: any[];
  REL_COMM: any[];
  button: boolean = false;
  showrefercode: boolean = false;
  showinput: boolean = false;
  disablerefcode: boolean = false;
  refercode: any;
  getrmcode: any;
  getrefcode: any;
  refUrl: any[];
  word: string;
  baseUrl: any;
  checkExist = new CheckLinkExists();
  pmsRMCode: any;
  CRMLeadEmail: string;
  CRMLeadMobile: string;
  relationshipDetails: boolean = false;
  hideRMCode: boolean = false;
  isCRMLead: boolean = false;
  LeadId: string;
  LeadSource: string;
  getCRMMobileOTP: number;
  introducerName: any;
  signIn: boolean = false;
  disableregbutton : boolean = true;


  producttypestatic: string = this.webService.getStaticAccounttype();

  private Refrealoptions: string[] = [];
  private options: string[] = ["TRADING+DEMAT", "ONLY DEMAT", this.producttypestatic];// ["TRADING", "DEMAT"];

  selectedQuantity = "TRADING+DEMAT";
  accountMode: boolean = true;
  referalCode: boolean = true;
  Producttype: string = null;
  accounttypedisabled: boolean = false;
  constructor(public ngxSmartModalService: NgxSmartModalService, private http: HttpClient, private router: Router, private webService: WebService, private route: ActivatedRoute, private eventManager: EventManagerService, private secureLS: SecureLocalStorage, private authService: Auth) {
    debugger;
    this.route.queryParams.subscribe(params => { this.Producttype = params['producttype']; });
    this.eventManager.registerEvent('DATA_FETCHED', this, (args: any) => {
      this.DropDownGroupArr;
    })
  }

  ngAfterViewInit() {

    const book: Object = {
      prop1: "test"
    };
    this.ngxSmartModalService.setModalData(book, "popuptwo");
  }
  ngOnInit() {

    debugger;
    this.disableregbutton = true;
    const parsedUrl = new URL(window.location.href);
    this.baseUrl = parsedUrl.origin + parsedUrl.pathname;
    this.checkExist.baseUrl = this.baseUrl;

    this.route.queryParamMap.subscribe(queryParams => {
      this.getrmcode = queryParams.get("rm_code");
      this.getrefcode = queryParams.get("refcode");

      if ((this.getrmcode != null || this.getrmcode != "") && (this.getrefcode != null || this.getrefcode != "")) {
        this.relationshipDetails = false;
        this.hideRMCode = false;
      }

      this.checkExist.rmcode = this.getrmcode;
      this.checkExist.refcode = this.getrefcode;
    })
    this.RmToken = this.secureLS.getStorage('RMTk');
    if (this.RmToken.value != undefined && this.RmToken.value != "") {
      this.pmsRMCode = this.RmToken.value.employeeCode || this.RmToken.value.dataset.employeeCode;
    }


    if (this.RmToken.value == "" && (this.getrmcode == null || this.getrmcode == "") && (this.getrefcode == null || this.getrefcode == "")) {
      this.relationshipDetails = true;
      this.hideRMCode = true;
    }


    if (this.getrefcode != null) {
      this.Apiurl = "api/Application/CheckExistLink"
      this.webService.postData(this.Apiurl, this.checkExist).subscribe((data: any) => {
        if (data.statusCode != 201) {
          bootbox.alert("Your Referal Link is Invalid");
          this.secureLS.removeStorage();
          localStorage.clear();
          let that = this;
          that.router.navigate(['/login']);
        }

      })
    }
    this.button = false;
    this.showrefercode = false;
    // this.GetAccountCat("TRADING");
    setTimeout(() => { $('#newsTicker1').breakingNews(); }, 500)
    this.route.queryParamMap.subscribe(queryParams => {
      this.userType = queryParams.get("rm_code");

      if (this.Producttype != null && this.Producttype != undefined && this.Producttype != "") {
        this.registerobj.ProductId = this.Producttype;

      }

      //check in url parameter send or not 
      if (this.Producttype == this.webService.getStaticPMSProducttype()) {
        this.selectedQuantity = this.producttypestatic;
        this.registerobj.AccountType = this.selectedQuantity;
        this.accounttypedisabled = true;
        this.registerobj.ProductId = this.Producttype;
        //this.GetRefrealCode(this.registerobj.ProductId);
      }


      this.RefCodeType = queryParams.get("refcode");
      debugger;
        if (this.RefCodeType != null) {
          this.registerobj.referby = this.RefCodeType;
          this.registerobj.Referalcode = this.userType;
          this.registerobj.Createby = this.userType;
          this.showrefercode = true;
          this.disablerefcode = true;


          if (this.router.url.indexOf('/register?rm_code') > -1) {

            debugger;

              this.registerobj.LinkFlag = "ByRefer";
         

          }
          else {
            this.showrefercode = false;
          }

          if (this.userType != null && this.userType == '939752') {
            this.registerobj.Referalcode = this.userType;
            this.registerobj.Createby = 'Client';
            this.referalmcode = true;
          } else {
            debugger;
            this.RmToken = this.secureLS.getStorage('RMTk');

            if (this.RmToken.value != undefined && this.RmToken.value != "") {
              this.Rmcode = this.RmToken.value.employeeCode || this.RmToken.value.dataset.employeeCode;

            }

          }
        }



      if (this.userType == null) {
        debugger;
        if (this.pmsRMCode != null) {
          this.button = true;

          if (this.RmToken.value.branchLogin == true) {
            this.showrefercode = true;
          } else {
            this.showrefercode = false;
          }

          this.registerobj.Referalcode = this.pmsRMCode;
          this.registerobj.AccountMode = "1";
          this.referalmcode = true;
          this.referalmcode = true;
          this.disablerefcode = false;

        }
        else if (this.userType != null) {
          debugger;
          this.showrefercode = true;
          this.registerobj.Referalcode = this.Rmcode;
          this.Refrealoptions = [this.Rmcode];
          this.registerobj.AccountMode = "1";
          this.referalmcode = true;
          this.disablerefcode = false;

        } else {
          if (this.Producttype == this.webService.getStaticPMSProducttype()) {
            this.registerobj.Referalcode = "939178";
            this.Refrealoptions = [this.registerobj.Referalcode];
          } else {
            if (this.userType != null) {

              this.registerobj.Referalcode = this.userType;
            }
            else {
              this.registerobj.Referalcode = "939752";
            }


            this.Refrealoptions = [this.registerobj.Referalcode];
          }
          //this.accountMode = true; 
        }

      }
      else { this.registerobj.AccountMode = "1"; }
      this.dropdown();
      if (this.Rmcode != null) {
        debugger;
        this.loginID = this.Rmcode;

      }
      else {
        this.loginID = 'Client';
      }
      if (this.pmsRMCode != null && this.pmsRMCode != undefined && this.pmsRMCode != "") {
        this.loginID = this.pmsRMCode;
      }
    })

    //Added by laxmi on 28-Oct-2022 For CRM Lead Task!
    this.route.queryParamMap.subscribe(queryParams => {
      this.LeadId = queryParams.get("ID");
      this.LeadSource = queryParams.get("LeadSource");
    });

    if (this.LeadId != null && this.LeadSource != null) {

      this.Apiurl = "api/Client/GetCRMLeadbyId?LeadId=" + this.LeadId + "&LeadSource=" + this.LeadSource;
      this.webService.getData(this.Apiurl).toPromise().then((data: any) => {
        if (data.dataset != null && data.dataset != undefined) {

          localStorage.setItem('IsCRMLeadby', "yes");
          var getMobileOTP = data.dataset.mobile_otp;
          this.getCRMMobileOTP = +getMobileOTP;
          this.CRMLeadEmail = data.dataset.clientEmail;
          this.CRMLeadMobile = data.dataset.clientMobile;
          this.registerobj.Mobileotp = this.getCRMMobileOTP;
          this.registerobj.Emailid = this.CRMLeadEmail;
          this.registerobj.Mobileno = this.CRMLeadMobile;
          this.isCRMLead = true;
        }
      });
    }
  }

  ngOnDestroy(): void {

  }

  async postreferby() {

    debugger;



    this.Apiurl = "api/Registration/referby";
    await this.webService.postData(this.Apiurl, this.registerobj).toPromise().then(async (data: any) => {

      debugger;


      console.log("test data", data);
      if (data.statusCode == 204) {
        bootbox.alert(data.message);
        return this.refcodeValue = false;
      }
      else {
        if (data.statusCode == 200) {
          return this.refcodeValue = true;
        }
      }

    })
  }
  dropdown() {
    debugger
    this.Apiurl = "api/Utils/fetchdropdownsofrelation";
    this.webService.getData(this.Apiurl).subscribe((data: any) => {
      var dropDownKey = data.dataset.map((m) => m.codetype).filter((f, i, ar) => ar.indexOf(f) === i);
      var groupArr = [];
      var group = data.dataset.reduce((accumulator, item, i, arr) => {
        if (dropDownKey.length) {
          var pop = dropDownKey.shift();
          var list = arr.filter((f) => f.codetype == pop);
          groupArr[pop] = list;
          //accumulator.push(...list);
        }
        return accumulator;
      }, []); 

      this.DropDownGroupArr = groupArr;
      this.RelationDropdown = this.DropDownGroupArr['REL_COMM'];

      this.RelationDropdown_codedesc = this.RelationDropdown.filter(x => x.codevalueid != 58001);
    },
      error => {
        console.log('Error', error)
      });
  }
  resendotp(registerobj) {
    debugger
    this.registerobj.Mobileotp = null;
    this.registerobj.Emailotp = null;
    this.registerobj.Ekycclientcode = this.EkycRefCode;
    this.Apiurl = "api/Registration/resendotp";
    this.registerobj2.Mobileno = this.webService.encryptData(this.registerobj.Mobileno);
    this.registerobj2.Emailid = this.webService.encryptData(this.registerobj.Emailid);
    this.registerobj2.Ekycclientcode = this.EkycRefCode;
    this.webService.postData(this.Apiurl, this.registerobj2).subscribe((data: any) => {

      if (data.statusCode == 200) {
        bootbox.alert(data.message);
        return false;
      }
      else {
        if (data.statusCode == 204) {
          this.registerobj.Mobileotp = null;
          this.registerobj.Emailotp = null;
          bootbox.alert(data.message);
        }
      }
    })
  }

  EmailOnChange(cliType, email) {
    debugger
    console.log(this.registrationfrm)
    //if (!this.registrationfrm.valid) {
    //  this.validation = true;
    //}
    if (email == "" || email == null) {

    }
    else {
      this.searchfamily.SearchType = "02";
      this.searchfamily.Relation = cliType;
      this.searchfamily.SearchValue = email;

      //this.webService.gettokendata(this.searchfamily).subscribe(token => {
      this.Apiurl = "api/Registration/getrelation";
      this.webService.postData(this.Apiurl, this.searchfamily).subscribe((token: any) => {
        this.emailRelation = token;
        debugger
        if (cliType == 58004 && this.emailRelation.dataset.dataset.is_self == "Not Allowed") {
          this.hideEmailbut = true;
          this.hidedropvalue = "58004";
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-success mb-2'></i><br>Relationship with email input have been already with us, Please change relationship or provide new email to proceed.</h6></div>",
            size: 'large'
          });
        } else if (cliType == 58005 && this.emailRelation.dataset.dataset.is_spouse == "Not Allowed") {
          this.hideEmailbut = true;
          this.hidedropvalue = "58005";
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-success mb-2'></i><br>Relationship with email input have been already with us, Please change relationship or provide new email to proceed.</h6></div>",
            size: 'large'
          });
        } else if (cliType == 58002 && this.emailRelation.dataset.dataset.is_dependent_children == "Not Allowed") {
          this.hideEmailbut = true;
          this.hidedropvalue = "58002";
          this
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-success mb-2'></i><br>Relationship with email input have been already with us, Please change relationship or provide new email to proceed.</h6></div>",
            size: 'large'
          });
        } else if (cliType == 58003 && this.emailRelation.dataset.dataset.is_dependent_parents == "Not Allowed") {
          this.hideEmailbut = true;
          this.hidedropvalue = "58003";
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-success mb-2'></i><br>Relationship with email input have been already with us, Please change relationship or provide new email to proceed.</h6></div>",
            size: 'large'
          });
        } else {
          this.hideEmailbut = false;
          this.hidedropvalue = " ";
        }
      })
    }
  }

  MobileOnChange(cliType, number) {
    debugger
    if (number == "" || number == null) {

    }
    else {
      this.searchfamily.SearchType = "01";
    this.searchfamily.Relation = cliType;
    this.searchfamily.SearchValue = number;

    // this.webService.gettokendata(this.searchfamily).subscribe(token => {
    this.Apiurl = "api/Registration/getrelation";
    this.webService.postData(this.Apiurl, this.searchfamily).subscribe((token: any) => {
      this.mobileRelation = token;
      debugger
      if (cliType == 58004 && this.mobileRelation.dataset.dataset.is_self == "Not Allowed") {
        this.hideMobilebut = true;
        this.hidedropvalue = "58004";
        bootbox.alert({
          message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-success mb-2'></i><br>Relationship with mobile input have been already with us, Please change relationship or provide new email to proceed.</h6></div>",
          size: 'large'
        });
      } else if (cliType == 58005 && this.mobileRelation.dataset.dataset.is_spouse == "Not Allowed") {
        this.hideMobilebut = true;
        this.hidedropvalue = "58005";
        bootbox.alert({
          message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-success mb-2'></i><br>Relationship with mobile input have been already with us, Please change relationship or provide new email to proceed.</h6></div>",
          size: 'large'
        });
      } else if (cliType == 58002 && this.mobileRelation.dataset.dataset.is_dependent_children == "Not Allowed") {
        this.hideMobilebut = true;
        this.hidedropvalue = "58002";
        bootbox.alert({
          message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-success mb-2'></i><br>Relationship with mobile input have been already with us, Please change relationship or provide new email to proceed.</h6></div>",
          size: 'large'
        });
      } else if (cliType == 58003 && this.mobileRelation.dataset.dataset.is_dependent_parents == "Not Allowed") {
        this.hideMobilebut = true;
        this.hidedropvalue = "58003";
        bootbox.alert({
          message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-success mb-2'></i><br>Relationship with mobile input have been already with us, Please change relationship or provide new email to proceed.</h6></div>",
          size: 'large'
        });
      } else {
        this.hideMobilebut = false;
        this.hidedropvalue = " ";
      }
    })
    }
    

  }

  RegisterInsertion(has_PMS) {
    debugger;
    if (this.registrationfrm.valid) {
      this.validation = false;
      this.registerobj.Createby = this.loginID;
      if (has_PMS) {
        this.registerobj.ProductId = this.webService.getStaticPMSProducttype();
      }
      this.registerobj.PmsTermsAgree = has_PMS;

      if (this.registerobj.referby != undefined && this.registerobj.referby != this.registerobj.Createby) {
        this.postreferby();
      } else {
        this.refcodeValue = true;
      }

      if (this.refcodeValue == true) {

        this.validation = false;
        this.registerobj.Createby = this.loginID;
        this.Apiurl = "api/Registration/Clientregister";
        this.registerobj1.ProductId = this.registerobj.ProductId;
        this.registerobj1.RelationshipEmail = this.registerobj.RelationshipEmail;
        this.registerobj1.RelationshipMobile = this.registerobj.RelationshipMobile;
        this.registerobj1.TermsServices = true;
        this.registerobj1.AccountMode = "0";
        this.registerobj1.AccountType = this.registerobj.AccountType;
        this.registerobj1.LinkFlag = this.registerobj.LinkFlag;
        this.registerobj1.Referalcode = this.registerobj.Referalcode;
        this.registerobj1.referby = this.registerobj.referby;
        this.registerobj1.Createby = this.registerobj.Createby;
        this.registerobj1.Mobileno = this.webService.encryptData(this.registerobj.Mobileno);
        this.registerobj1.Emailid = this.webService.encryptData(this.registerobj.Emailid);
        this.webService.postData(this.Apiurl, this.registerobj1).subscribe((data: any) => {
          debugger;
          this.EkycRefCode = data.dataset.ekycclientcode;

          if (data.statusCode == 204) {
            bootbox.alert(data.dataset.message);
				this.signIn == true;				   
            	
            this.validation = true;
          }
   //       if (data.statusCode == 201) {
   //         // bootbox.alert("You Mobile Or Emaild Exits With this Relationship.If you want to login please click on sign in here button.");
   //         // this.validation = true;
			
   //         let that = this;
   //         bootbox.confirm({
   //           message: "<div class='text-center'> <h6><i class='fa fa-check-circle fa-2x text-success mb-2'> </i><br>Your Mobile Or Emaild Exits With this Relationship. If you want to continue click on continue button and if you want to open a different account so click on cancel</h6 > </div>",
   //           buttons: {
   //             confirm: {
   //               label: 'Continue',
   //               className: 'btn-success'

   //             }
   //           },
             
   //           callback: async function (result) {
   //             if (result) {
   //               //localStorage.setItem('Email', that.registerobj.Emailid);
   //               //console.log("set email", localStorage.setItem('Email', that.registerobj.Emailid));
   //               that.router.navigate(['/login']);
   //             }
                
   //           }

   //         });
			//}
          if (data.statusCode == 201) {
            bootbox.alert("You Mobile Or Emaild Exits With this Relationship.If you want to login please click on sign in here button.");
            this.validation = true;
          }
          else {
            if (data.statusCode == 200) {
              localStorage.setItem('EkycClientCode1', this.EkycRefCode);
              let that = this;
              bootbox.alert({
                message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>You have successfully signed up. Thank You for signing up and opening a new account</h6></div>",
                size: 'large'
              });
              this.Hidediv = true;
            }
          }
        })
      }
    }
    else {
      this.validation = true;
    }

  }


  registration(registerobj) {
    debugger;

    if (this.registerobj.referby != undefined && this.registerobj.referby != this.registerobj.Createby) {
      this.postreferby();
    } else {
      this.refcodeValue = true;
    }

    debugger
    this.refercode = registerobj.referby;
    this.secureLS.setStorage('ReferBy', this.refercode);

    //if (this.registerobj.Mobileno.length == 10) {
    if (!this.registrationfrm.valid) {
      this.validation = true;
      
    }
    else {
      //if (this.registerobj.Mobileno.length == 10) {
      if (this.registerobj.TermsServices == false) {
        bootbox.alert({
          message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>Please check I Agree checkbox</h6></div>",
          size: 'large'
        });
      }
      else {

        if (this.registrationfrm.valid) {
          debugger;

                debugger;
                if (this.registerobj.AccountType == this.producttypestatic) {
                  bootbox.dialog({
                    message: '	Minimum investment amount : Rs. 50 lakh. <br> Only Indian Single Individual can open the account.To open the account in - Joint holding/ HUFs / Corporates & NRIs please contact your nearest branch or mail us at <a href="pmsdesk@rathi.com">pmsdesk@rathi.com</a>',
                    title: "PMS Confirmation",
                    buttons: {
                      ok: {
                        label: "Agree",
                        className: "btn-success",
                        callback: (function () {
                          bootbox.dialog({
                            message: '<b>Demat Account is going to be opened with Anand Rathi Shares & Stock Brokers.</b> <br> <p> <b> PMS Account is going to be opened with Anand Rathi Advisors.</b> <br> We have included a summary below to help and guide you through the process <br> 	KYC Documents required & things you can keep with yourself handy: <br>    1.	Aadhar Card / Passport / Driving License / Latest Electricity bill / Latest Landline bill / Voter ID Card / Bank Statement – Any one <br> 2.	PAN Card <br> 3.	Cancelled Cheque / Latest Bank Passbook / Latest Bank Statement – Must display MICR/IFSC Code <br> 4.	Self-passport size photograph – Optional, as you will get an option to click a live image <br> 5. Nominee Document Proof <br> 6. Please keep the soft copy of the above documents and also keep an imange of your signature required to be uploaded to complete KYC.',
                            title: "KYC Documents required ",
                            buttons: {
                              ok: {
                                label: "OK",
                                className: "btn-success",
                                callback: (function () {
                                  this.RegisterInsertion(true);
                                }).bind(this)
                              }
                            }

                    })


                  }).bind(this)

                },
                close: {
                  label: "Close",
                  className: "btn-danger"
                }
              }
            });
          } else {
            this.RegisterInsertion(false);
          }
        }
      }
    }
  }
  //this function is used to agree pms account open confirmation validate


  openDialogMymodel() {
    this.ngxSmartModalService.getModal('popuptwo').open();
  }

  verfiyOtp() {



    debugger;

    if (!this.verifyForm.valid) {
      this.otpvalidation = true;
    } else {
      this.registerobj.Ekycclientcode = this.EkycRefCode;

      this.Apiurl = "api/Registration/VerfiyOtp";
      this.webService.postData(this.Apiurl, this.registerobj).subscribe((data: any) => {
        this.rmtoken = this.secureLS.getStorage('RMTk');

        this.secureLS.setStorage('TokenId', data.token);


        debugger;

        if (data.statusCode == 204) {
          bootbox.alert(data.message);
          return false;
        }

        else if (this.rmtoken.value.employeeCode != null && this.rmtoken.value.role != null && this.rmtoken.value.employeeCode != undefined) {
          this.secureLS.setStorage('LoginUserData', data);
          this.secureLS.setStorage('TokenId', data.token);
          this.checkClientIdentitySubmitted();
        }
        //Added by laxmi, for hide verify otp process and password!       
        else if (data.ekyc_code != undefined && data.ekyc_code != null) {
          debugger;

          this.secureLS.setStorage('LoginUserData', data);
          this.secureLS.setStorage('TokenId', data.token);
          this.checkClientIdentitySubmitted();
        }

        else {
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>You have successfully registered. Please continue for the next process.</h6></div>",
            size: 'large'
          });
          this.secureLS.setStorage('LoginUserData', data);
          this.secureLS.removeStorage();
          localStorage.clear();
          let that = this;
          that.router.navigate(['/login']);

        }
      })
    }
  }


  GetAccountCat(e) {
    debugger
    // let acctype = e
    // if (acctype == "02") {

    if (e == "PMS Demat") {
      this.disableregbutton = false;
      this.registerobj.AccountType = e;
      this.registerobj.ProductId = this.webService.getStaticPMSProducttype();
      this.referalCode = true;

      if (this.Rmcode != null) {
        this.button = true;
        this.showrefercode = true;
        this.registerobj.Referalcode = this.Rmcode;
        this.Refrealoptions = [this.Rmcode];
        this.registerobj.AccountMode = "1";
        this.referalmcode = true;
        this.referalCode = true;
      } else {
        this.registerobj.Referalcode = this.pmsRMCode;//"939178";
      }
    } else {
      this.disableregbutton = true;
      if (e == this.webService.getStaticAccounttype()) {
        this.registerobj.AccountType = e;
        this.registerobj.ProductId = this.webService.getStaticPMSProducttype();
        this.referalCode = true;

        if (this.Rmcode != null) {
          this.button = true;
          this.showrefercode = true;
          this.registerobj.Referalcode = this.Rmcode;
          this.Refrealoptions = [this.Rmcode];
          this.registerobj.AccountMode = "1";
          this.referalmcode = true;
          this.referalCode = true;
        } else {
          this.registerobj.Referalcode = this.pmsRMCode;//"939178";
        }

      }
      else {
        debugger;
        this.referalCode = true;
        this.registerobj.AccountType = e;
        if (this.Producttype != null && this.Producttype != undefined && this.Producttype != "") {
          this.registerobj.ProductId = this.Producttype;
        } else {
          this.registerobj.ProductId = this.defaultproductid;
        }

        if (this.userType == null) {

          //if (this.pmsRMCode != null) {
          //  this.button = true;
          //  this.showrefercode = true;
          //  this.registerobj.Referalcode = this.Rmcode;
          //  this.Refrealoptions = [this.Rmcode];
          //  this.registerobj.AccountMode = "1";
          //  this.referalmcode = true;

          //} else {
          if (this.Producttype != this.webService.getStaticPMSProducttype()) {
            this.registerobj.Referalcode = this.pmsRMCode;//"939752";
            this.Refrealoptions = [this.registerobj.Referalcode];
          }
          //this.accountMode = true; 
          //}
        }

      }
    }

    

  }
  checkClientIdentitySubmitted() {
    debugger
    var ids = this.registerobj.Ekycclientcode;
    let url = "api/Authenticate/CheckClientIdentitySubmitted/" + ids;

    this.webService.getData(url).subscribe((res: any) => {
      const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
      this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
      if (res != null) {
        if (res.statusCode == 404) {
          this.router.navigate(['client-basic-details/pan-search']);
        }
        if (res.statusCode == 200) {
          this.router.navigate(['client-basic-details/Client-DashBord']);
        }
        //if (res.statusCode == 201) {
        //  this.router.navigate(['client-account/payment']);
        //}
      }
    }, error => {

    });
  }
  logout() {
    debugger
    this.secureLS.removeStorage();
    localStorage.clear();
    if (localStorage.length == 0) {
      this.secureLS.removeStorage();
      localStorage.clear();
      let that = this;
      this.authService.tokenExpired();
      that.router.navigate(['/login']);
    }
  }


  GetRefrealCode(productid) {
    debugger;
    if (this.Rmcode != null) {
      this.button = true;
      this.showrefercode = true;
      this.registerobj.Referalcode = this.Rmcode;
      this.Refrealoptions = [this.Rmcode];
      this.registerobj.AccountMode = "1";
      this.referalmcode = true;
      this.referalCode = true;
    } else {
      this.Apiurl = "/api/Registration/GetRefrealCode/" + productid;
      this.webService.getData(this.Apiurl).toPromise().then((data: any) => {
        debugger;
        console.log("test data", data)
        this.Refrealoptions = data.dataset;
        this.Refrealoptions.unshift("939178");
        this.referalCode = false;
      }, error => {
        console.log('Error', error);
      });
    }
  }

  //Added by Yasmin
  //For check referral code valid or not.
  CheckRefCode(registerobj) {
    this.Apiurl = "api/Registration/CheckRefCode/" + this.registerobj.referby;
    this.webService.getData(this.Apiurl).subscribe((data: any) => {
      debugger;
      if (data.statusCode == 200) {
        this.showinput = true;
        this.registerobj.introducerName = data.dataset.introducername;
       

        console.log("introducerName=>", this.introducerName);
        
      }
      if (data.statusCode == 204) {
        bootbox.alert("Entered referral code invalid");
      }
    })
  }

}

export class registerobj {
  Mobileno: string;
  RelationshipEmail: string = "58004";
  Emailid: string;
  RelationshipMobile: string = "58004";
  Referalcode: string;
  TermsServices: boolean = true;
  Mobileotp: number;
  Emailotp: number;
  Ekycclientcode: string;
  AccountMode: string = "0";
  AccountType: string = "TRADING+DEMAT";
  Createby: string;
  
  referby: any;
  LinkFlag: string = "";

  PmsTermsAgree: boolean = false;
  ProductId: string = "P000001";
  introducerName: any;

}

export class SearchContactParm {
  SearchType: string;
  SearchValue: string;
  Relation: string;
}

export class CheckLinkExists {
  baseUrl: string;
  rmcode: string;
  refcode: string;

}




